export enum IssueCategory {
  DELIVERY_FAILURE = 'DELIVERY_FAILURE',
  ONGOING_ORDER_ISSUE = 'ONGOING_ORDER_ISSUE',
  ORDER_POTENTIAL_FRAUD = 'ORDER_POTENTIAL_FRAUD',
  ORDER_NOTE_ISSUE = 'ORDER_NOTE_ISSUE',
  ORDER_REJECTION = 'ORDER_REJECTION',
  REJECTION_ORDER_PUNCHING = 'REJECTION_ORDER_PUNCHING',
}
